/**
 * Shown in the payment step when the form token could not be obtained.
 * Replaces the previous permanent "Cargando opciones de pago…" spinner.
 * `onRetry` re-requests the token reusing the existing orderId — it never
 * creates a new order/ticket.
 */
type Props = {
  message?: string | null;
  onRetry: () => void;
  retrying?: boolean;
  isSpanish?: boolean;
};

const PaymentErrorRetry = ({ message, onRetry, retrying = false, isSpanish = true }: Props) => (
  <div className="flex flex-col items-center justify-center py-10 gap-4 text-center">
    <svg
      className="w-11 h-11 text-red-400"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
      />
    </svg>
    <p className="text-sm text-gray-600 max-w-xs">
      {message ||
        (isSpanish
          ? 'No se pudo generar el formulario de pago.'
          : 'The payment form could not be generated.')}
    </p>
    <button
      type="button"
      onClick={onRetry}
      disabled={retrying}
      className="text-sm text-copper hover:underline font-semibold disabled:opacity-60 disabled:cursor-not-allowed"
    >
      {retrying
        ? isSpanish
          ? 'Reintentando…'
          : 'Retrying…'
        : isSpanish
          ? 'Reintentar'
          : 'Try again'}
    </button>
  </div>
);

export default PaymentErrorRetry;
